var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDecsendingSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.799004 5.10433C0.388721 5.10433 0.172298 4.61838 0.446763 4.31342L3.64774 0.756777C3.83599 0.54761 4.16397 0.54761 4.35222 0.756777L7.5532 4.31342C7.82767 4.61838 7.61124 5.10433 7.20096 5.10433L0.799004 5.10433Z",
    fill: "#8993A0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.20096 8.89548C7.61124 8.89548 7.82767 9.38143 7.5532 9.68639L4.35222 13.243C4.16397 13.4522 3.83599 13.4522 3.64774 13.243L0.446763 9.68639C0.172298 9.38143 0.388721 8.89547 0.799004 8.89547L7.20096 8.89548Z",
    fill: "#0050AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecsendingSort);
export default __webpack_public_path__ + "static/media/decsending-sort.9f8abecbf89338a36b3105e4bfabbaed.svg";
export { ForwardRef as ReactComponent };